import { Redirect, useLocalSearchParams } from 'expo-router';

export default function KursiPlayLegacyEditorRedirect() {
  const { worldId } = useLocalSearchParams<{ worldId?: string | string[] }>();
  const canonicalId = Array.isArray(worldId) ? worldId[0] : worldId;
  return <Redirect href={canonicalId ? `/learn/creator/edit/${encodeURIComponent(canonicalId)}` : '/learn/creator'} />;
}
